import React from "react";
import { useState } from "react";

export default function ({
  label,
  name,
  register,
  errorMessage = "",
  type = "text",
  classes = "",
  parentClasses = "",
  labelClasses = "",
  pattern = "",
  autoComplete = "",
  required = false,
  readOnly=false
}) {

  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <div className={`fv-row mb-10${parentClasses ? " " + parentClasses : ''}`}>
        <label className={`form-label fw-bolder color-dark-grey${labelClasses ? " " + labelClasses : ""}`}>
          {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
          </label>
        <input
          className={`form-control form-control-lg form-control-solid${classes ? " " + classes : ''}
          ${type == "password" ? " " + 'pass-eye' : ''}`}
          type={showPassword ? "text" : type}
          {...register(name)}
          {...pattern && (pattern = {pattern})}
          required={required}
          autoComplete={autoComplete}
          readOnly={readOnly}
        />

        {type == "password" && (<div className="show-pass-parent" onClick={() => { setShowPassword(!showPassword) }}>
          <div className="show-pass">
            <i className={`fas fa-eye${showPassword ? "-slash" : ''}`}></i>
          </div>
        </div>)}

        {errorMessage && (
          <div className="fv-plugins-message-container invalid-feedback">
            <div>{errorMessage}</div>
          </div>
        )}
      </div>
    </>
  );
}